import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MessageSquare } from "lucide-react";
import Reveal from "./Reveal";
import { BACKEND, COMMUNITY_TILE_META, communityMediaUrl } from "./data";
import { useT } from "./i18n";

export default function CommunityPreview() {
  const { t } = useT();
  const [byCat, setByCat] = useState({});

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND}/api/community/posts`)
      .then((r) => (r.ok ? r.json() : { posts: [] }))
      .then((d) => {
        if (cancelled) return;
        const map = {};
        (d.posts || []).forEach((p) => { if (!map[p.category]) map[p.category] = p; });
        setByCat(map);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-[#C4A46B]">{t.community.eyebrow}</p>
            <h2 className="mt-3 max-w-xl font-serif text-4xl leading-tight text-[#173A2C] sm:text-5xl">{t.community.heading}</h2>
          </div>
          <Link to="/community" data-testid="community-view-all" className="inline-flex items-center gap-1 rounded-full border border-[#1F4A38] px-5 py-2.5 text-sm font-semibold text-[#1F4A38] transition-colors hover:bg-[#1F4A38] hover:text-white">
            {t.community.visit} <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>

        <div className="mt-10 columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
          {COMMUNITY_TILE_META.map((tile, i) => {
            const post = byCat[tile.key];
            const media = post?.media?.find((m) => m.review_status === "approved" && m.kind === "post_image");
            const tall = i % 3 === 1;
            const label = t.community.tiles[tile.key] || tile.key;
            return (
              <Reveal key={tile.key} delay={(i % 3) + 1} className="break-inside-avoid">
                <Link to="/community" data-testid={`community-tile-${i}`} className="group block overflow-hidden rounded-2xl border border-[#E8E4DB] bg-white card-lift">
                  <div className={`relative overflow-hidden ${tall ? "h-64" : "h-44"}`}>
                    <img src={media ? communityMediaUrl(media.id) : tile.img} alt={label} loading="lazy" decoding="async" className="img-zoom h-full w-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <span className="absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-semibold text-white" style={{ backgroundColor: tile.accent }}>{label}</span>
                  </div>
                  <div className="p-4">
                    <p className="line-clamp-2 text-sm font-medium text-[#2C2A29]">{post?.title || t.community.latest}</p>
                    {post && (
                      <div className="mt-2 flex items-center gap-1 text-xs text-[#8a8580]">
                        <MessageSquare className="h-3.5 w-3.5" /> {post.comment_count} {post.comment_count === 1 ? t.community.comments_one : t.community.comments_other}
                      </div>
                    )}
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
